import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  checkPermision,
  useStylesReddit,
  useStyles,
  iconError,
  formLabelsTheme,
  validatePost,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import moment from "moment";
import { editReportIssue, editReportIssueAll } from "./reportIssueSlice";
import { FormHelperText, TextField, ThemeProvider } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { selectReasonCode } from "../miscellaneous/MiscellaneousSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ReportIssueTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
  setFormValues,
  formValues,
  isOpen,
  setShow,
  selectedRows,
  setSelectedRows,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const dataReason = useSelector(selectReasonCode);

  const history = useHistory();
  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);

    // Filter data dengan resolve_date yang tidak null
    const filteredData = data.filter((item) => item.resolve_date !== null);

    // Mengonversi data menjadi array string
    const resolvedDates = filteredData.map((item) => item.reportissue_id);
    console.log(resolvedDates, "resolvedDates");
    setlistNonSelected(resolvedDates);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);
  const [showEdit, setShowEdit] = useState(false);
  const [showResolveAll, setShowResolveAll] = useState(false);
  const [showEditType, setShowEditType] = useState("");
  const [listNonSelected, setlistNonSelected] = useState([]);

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        {row.resolve_date === null && (
          <div>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={() => {
                  setFormValues({
                    reportissue_id: {
                      value: row.reportissue_id,
                      error: false,
                      required: "N",
                    },
                    vin: {
                      value: row.vin,
                      error: false,
                      required: "Y",
                    },
                    issue_date: {
                      value: moment(row.issue_date).format("YYYY-MM-DD"),
                      error: false,
                      required: "Y",
                    },
                    hold_reason: {
                      value: row.hold_reason,
                      error: false,
                      required: "N",
                    },
                    hold_remarks: {
                      value: row.hold_remarks,
                      error: false,
                      required: "N",
                    },
                    resolve_date: {
                      value: "",
                      error: false,
                      required: "N",
                    },
                    resolve_remarks: {
                      value: "",
                      error: false,
                      required: "N",
                    },
                  });
                  setShowEdit(true);
                  setShowEditType("Edit");
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                </span>
              </div>
            </OverlayTrigger>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Resolve</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={() => {
                  setFormValues({
                    reportissue_id: {
                      value: row.reportissue_id,
                      error: false,
                      required: "N",
                    },
                    vin: {
                      value: row.vin,
                      error: false,
                      required: "Y",
                    },
                    issue_date: {
                      value: moment(row.issue_date).format("YYYY-MM-DD"),
                      error: false,
                      required: "Y",
                    },
                    hold_reason: {
                      value: row.hold_reason,
                      error: false,
                      required: "N",
                    },
                    hold_remarks: {
                      value: row.hold_remarks,
                      error: false,
                      required: "N",
                    },
                    resolve_date: {
                      value:
                        row.resolve_date === null
                          ? ""
                          : moment(row.resolve_date).format("YYYY-MM-DD"),
                      error: false,
                      required: "Y",
                    },
                    resolve_remarks: {
                      value: "",
                      error: false,
                      required: "N",
                    },
                  });
                  setShowEdit(true);
                  setShowEditType("Resolve");
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
                  />
                </span>
              </div>
            </OverlayTrigger>
          </div>
        )}
      </>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { width: "60px" },
      headerAlign: "center",
    },
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Issue Date",
      dataField: "issue_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
    },

    {
      text: "Hold Reason",
      dataField: "hold_reason_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Hold Remarks",
      dataField: "hold_remarks",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Inspection Status",
      dataField: "inspection_result",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Resolution Date",
      dataField: "resolve_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
    },

    {
      text: "Resolution Remark",
      dataField: "resolve_remarks",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Issuer",
      dataField: "created_user",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Resolver",
      dataField: "resolver",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      style: { minWidth: "200px" },
      headerAlign: "center",
      align: "center",
    },
  ];

  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };
  const handleSave = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    let params;

    if (showEditType === "edit") {
      params = {
        reportissue_id: formValues.reportissue_id.value,
        vin: formValues.vin.value,
        issue_date: formValues.issue_date.value,
        remarks: formValues.hold_remarks.value,
        hold_reason: formValues.hold_reason.value,
      };
    } else {
      params = {
        reportissue_id: formValues.reportissue_id.value,
        vin: formValues.vin.value,
        issue_date: formValues.issue_date.value,
        remarks: formValues.hold_remarks.value,
        hold_reason: formValues.hold_reason.value,
        resolve_date: formValues.resolve_date.value,
        resolve_remarks: formValues.resolve_remarks.value,
      };
    }

    try {
      const response = await dispatch(editReportIssue(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleSearch();
        await handleClose();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleResolveAll = async () => {
    // if (!validatePost(formValues, setFormValues)) {
    //   return;
    // }

    const params = selectedRows.map((item, index) => {
      return {
        reportissue_id: item.reportissue_id,
        resolve_date: formValues.resolve_date.value,
        resolve_remarks: formValues.resolve_remarks.value,
      };
    });

    console.log(params, "params");
    try {
      const response = await dispatch(editReportIssueAll(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await setSelectedRows([]);
        await handleSearch();

        await handleClose();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const reasonOptions = dataReason.map((e) => {
    return {
      value: e.reasoncode_id,
      label: e.reasoncode_code,
      name: e.reasoncode_name,
    };
  });

  const handleClose = () => {
    setFormValues({
      reportissue_id: {
        value: "",
        error: false,
        required: "N",
      },
      vin: {
        value: "",
        error: false,
        required: "Y",
      },
      issue_date: {
        value: "",
        error: false,
        required: "Y",
      },
      hold_reason: {
        value: "",
        error: false,
        required: "N",
      },
      hold_remarks: {
        value: "",
        error: false,
        required: "N",
      },
      resolve_date: {
        value: "",
        error: false,
        required: "N",
      },
      resolve_remarks: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setShowEdit(false);
    setShowEditType("");
    setShowResolveAll(false);
    setSelectedRows([]);
  };

  const onSelectRow = {
    mode: "checkbox",
    nonSelectable: listNonSelected,
    onSelectAll: (status) => {
      if (status === true) {
        const filteredData = tableData.filter(
          (item) => !listNonSelected.includes(item.reportissue_id)
        );

        setSelectedRows(filteredData);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="reportissue_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
        selectRow={{
          ...onSelectRow,
          selected: selectedRows.map((row) => row.reportissue_id),
        }}
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {/* Footer */}
      <Row className="mt-4 mr-5">
        {selectedRows.length > 0 && (
          <Button
            className="btn btn-primary my-btn-primary-dark text-bold mb-5 mr-5"
            onClick={() => setShowResolveAll(true)}
          >
            Resolve All
          </Button>
        )}
      </Row>

      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showEdit}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Edit Report Issue
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <RedditTextField
                  required
                  label="VIN"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="vin"
                  onChange={handleChange}
                  disabled
                  value={formValues.vin.value}
                  error={formValues.vin.error}
                  helperText={
                    formValues.vin.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {iconError} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                />

                {showEditType === "Edit" ? (
                  <RedditTextField
                    required
                    label="Issue Date"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="issue_date"
                    type="datetime-local"
                    onChange={handleChange}
                    value={formValues.issue_date.value}
                    error={formValues.issue_date.error}
                    helperText={
                      formValues.issue_date.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                ) : (
                  <RedditTextField
                    required
                    label="Resolve Date"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="resolve_date"
                    type="datetime-local"
                    onChange={handleChange}
                    value={formValues.resolve_date.value}
                    error={formValues.resolve_date.error}
                    helperText={
                      formValues.resolve_date.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                )}
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                {" "}
                <Autocomplete
                  options={reasonOptions}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  value={
                    reasonOptions.find(
                      (option) => option.value === formValues.hold_reason.value
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    console.log(newValue, "newValue");
                    if (newValue === null) {
                      setFormValues({
                        ...formValues,
                        ["hold_reason"]: {
                          ...formValues["hold_reason"],
                          value: "",
                        },
                        ["hold_remarks"]: {
                          ...formValues["hold_remarks"],
                          value: "",
                        },
                      });
                    } else {
                      console.log(newValue.name, " newValue.name");

                      setFormValues({
                        ...formValues,
                        ["hold_reason"]: {
                          ...formValues["hold_reason"],
                          value: newValue.value,
                        },
                        ["hold_remarks"]: {
                          ...formValues["hold_remarks"],
                          value: newValue.name,
                        },
                      });
                    }
                  }}
                  disabled={showEditType === "Resolve" ? true : false}
                  renderInput={(params) => (
                    <RedditTextField
                      required
                      className={classes.margin}
                      {...params}
                      label="Hold Reason"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      placeholder="Select"
                      name="hold_reason"
                      value={formValues.hold_reason.value}
                      error={formValues.hold_reason.error}
                      helperText={
                        formValues.hold_reason.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  )}
                />
                {showEditType === "Edit" ? (
                  <RedditTextField
                    label="Remarks"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    // multiline
                    // rows="4"
                    name="hold_remarks"
                    onChange={handleChange}
                    value={formValues.hold_remarks.value}
                  />
                ) : (
                  <RedditTextField
                    label="Remarks"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    // multiline
                    // rows="4"
                    name="resolve_remarks"
                    onChange={handleChange}
                    value={formValues.resolve_remarks.value}
                  />
                )}
              </Col>
            </Row>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleSave} variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showResolveAll}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Resolve Selected Issues
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <RedditTextField
                  required
                  label="Resolve Date"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="resolve_date"
                  type="date"
                  onChange={handleChange}
                  value={formValues.resolve_date.value}
                  error={formValues.resolve_date.error}
                  helperText={
                    formValues.resolve_date.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {iconError} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                />
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                {" "}
                <RedditTextField
                  label="Remarks"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  // multiline
                  // rows="4"
                  name="resolve_remarks"
                  onChange={handleChange}
                  value={formValues.resolve_remarks.value}
                />
              </Col>
            </Row>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleResolveAll} variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
